import { PropsWithChildren } from 'react';
import * as RadixTabs from '@radix-ui/react-tabs';

import { cn } from '@components/primitives/utilities';

import { TriggerProps } from './Trigger';

import css from './styles.module.css';

export interface TabProps extends PropsWithChildren<TriggerProps> {
  className?: string;
  /** Keeps the content mounted, and only hidden, while another tab is open. */
  forceMount?: boolean;
}

export function Tab({ children, label, className, forceMount }: TabProps) {
  return (
    <RadixTabs.Content
      value={label}
      forceMount={forceMount || undefined}
      asChild
    >
      <div className={cn(className, forceMount && css.forcedPanel)}>
        {children}
      </div>
    </RadixTabs.Content>
  );
}
